/* <script  src="https://checkout.razorpay.com/v1/checkout.js"></script> */
/* Impliment Above Script In SPA Index.html */
export function redirectToPaymentPage(orderModel) {
    return new Promise(resolve => {
        let rOptions = {
            ...orderModel,
            // key: orderModel.keyId,
            order_id: orderModel.orderId,
            handler:(res)=>{
                let response = {
                    razorpayPaymentId:res.razorpay_payment_id,
                    razorpayOrderId: res.razorpay_order_id,
                    razorpaySignature:res.razorpay_signature,
                    status: "Success",
                    amount: orderModel.amount,
                    orderId: orderModel.orderIdInternal
                }
                resolve(response)
            },
            model:{
                ondismiss:(res)=>{
                    let response = {
                        razorpayPaymentId:res.razorpay_payment_id,
                        razorpayOrderId: res.razorpay_order_id,
                        razorpaySignature:res.razorpay_signature,
                        status: "Failure",
                        amount: orderModel.amount,
                        orderId: orderModel.orderIdInternal
                    }
                    resolve(response)
                    
                },
                // Boolean indicating whether pressing escape key
                // should close the checkout form. (default: true)
                escape: true,
                // Boolean indicating whether clicking translucent blank
                // space outside checkout form should close the form. (default: false)
                backdropclose: true,
                handleback: true,
                confirm_close: true,
                animation: true,
            },
            timeout: 120,
            send_sms_hash: true,
            retry:{
                enabled: false
            },
        }
        
        var rzp1 = new Razorpay(rOptions);
        rzp1.on('payment.failed', function (res) {
            let response = {
                razorpayPaymentId:res.razorpay_payment_id,
                razorpayOrderId: res.razorpay_order_id,
                razorpaySignature:res.razorpay_signature,
                status: "Failure",
                amount: orderModel.amount,
                orderId: orderModel.orderIdInternal
            }
            resolve(response);
        });
      rzp1.open();
      });
    }